export default "__VITE_ASSET__CaboxuoG__"